import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Project.css";

export default function Project(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const data = [
    {
      id: 1,
      image: "asos.png",
      title: "ASOS Clone",
      description:
        "This is online shoping website . This project includes features like buy product,  promo code, sign in, sign up, etc.",
      // demo: "https://naukriclone98.vercel.app/",
      demo: "https://asos-one.vercel.app/",
      code: "https://github.com/swapnilpreet/ASOS-project/tree/main/asos",
      stack: ["react.svg", "chkra.jpg", "redux.svg"],
    },
    {
      id: 2,
      image: "kfc.png",
      title: "KFC Clone",
      description:
        "Clone of KFC.com where users can purches food, This project includes features like sorting Dishes, adding foods to the cart, promo code, sign in, sign up, etc.",
      demo: "https://online.kfc.co.in/",
      code: "https://github.com/swapnilpreet/KFC-CLONE",
      stack: ["html.svg", "css.svg", "js.svg"],
    },
    {
      id: 3,
      image: "rfpng.png",
      title: "Rodan Field clone",
      description:
        "Clone of RodanField.com where users can buy premium cosmetic products. This project includes features like sorting products, adding products to the cart, promo code, sign in, sign up, etc.",
      demo: "https://github.com/swapnilpreet/Project_unit_2",
      code: "https://github.com/dipakshinde-art/Project_unit_2",
      stack: ["html.svg", "css.svg"],
    },
  ];

  return (
    <div>
      <ScreenHeading
        title={"Projects"}
        subHeading={"Look at My Work"}
      ></ScreenHeading>
      <div className="projects-container fade-in" id={props.id || ""}>
        {data.map((e) => (
          <div key={e.id} className="project-div">
            <div className="main-image">
              <img src={e.image} alt="" />
            </div>
            <h5>
              <b>{e.title}</b>
            </h5>
            <p>{e.description}</p>
            <div className="stack-img">
              {e.stack.map((ele, i) => (
                <img key={i} src={ele} />
              ))}
            </div>
            <div className="button-link">
              <div>
                <a href={e.demo}>
                  <button>
                    {/* <i className="fas fa-link">
                                        </i> */}
                    Demo
                  </button>
                </a>
              </div>
              <div>
                <a href={e.code}>
                  <button>Code</button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
